'use client'

import { AppVariant } from '../../enums'

import type { MobileMenuProps } from './MobileMenu.types'
import { AcademyMobileMenu } from './variants/AcademyMobileMenu'
import { ConferenceMobileMenu } from './variants/ConferenceMobileMenu'
import { GatewayMobileMenu } from './variants/GatewayMobileMenu'
import { ModulesMobileMenu } from './variants/ModulesMobileMenu'
import { PortalMobileMenu } from './variants/PortalMobileMenu'
import { VisionMobileMenu } from './variants/VisionMobileMenu'

function sharedVariantProps(props: MobileMenuProps) {
  const {
    isOpen,
    onClose,
    menuGroups = [],
    helpItems,
    onProfileClick,
    onHelpClick,
    onNavigationClick,
    onProjectClick,
    onWorkspaceClick,
    onOpenWorkspaceSettings,
    onOpenProjectSettings,
    onOpenProjectMembers,
    onInviteProjectClick,
    onInviteWorkspaceClick,
    onCreateProject,
    notificationBadge,
    onNotificationClick,
  } = props

  return {
    isOpen,
    onClose,
    menuGroups,
    helpItems,
    onProfileClick,
    onHelpClick,
    onNavigationClick,
    onProjectClick,
    onWorkspaceClick,
    onOpenWorkspaceSettings,
    onOpenProjectSettings,
    onOpenProjectMembers,
    onInviteProjectClick,
    onInviteWorkspaceClick,
    onCreateProject,
    notificationBadge,
    onNotificationClick,
  }
}

function portalMenuProps(props: MobileMenuProps) {
  const { addNewLabel, hideAddNew, onAddServiceClick, onAddProjectClick, onAddWorkspaceClick } = props

  return {
    ...sharedVariantProps(props),
    addNewLabel,
    hideAddNew,
    onAddServiceClick,
    onAddProjectClick,
    onAddWorkspaceClick,
  }
}

/**
 * MobileMenu - Unified mobile menu component that renders the appropriate variant
 * based on the appVariant prop.
 *
 * @deprecated Use the specific variant components directly:
 * - PortalMobileMenu for Portal app
 * - VisionMobileMenu for Vision app
 * - GatewayMobileMenu for Gateway app
 */
export function MobileMenu(props: MobileMenuProps) {
  switch (props.appVariant) {
    case AppVariant.ACADEMY:
      return (
        <AcademyMobileMenu isOpen={props.isOpen} onClose={props.onClose} onNavigationClick={props.onNavigationClick} />
      )
    case AppVariant.PORTAL:
      return <PortalMobileMenu {...portalMenuProps(props)} />
    case AppVariant.VISION:
      return <VisionMobileMenu {...sharedVariantProps(props)} />
    case AppVariant.GATEWAY:
      return <GatewayMobileMenu {...sharedVariantProps(props)} />
    case AppVariant.MODULES:
      return <ModulesMobileMenu {...sharedVariantProps(props)} />
    case AppVariant.CONFERENCE:
      return <ConferenceMobileMenu {...sharedVariantProps(props)} />
    default:
      return <PortalMobileMenu {...portalMenuProps(props)} />
  }
}
